import { getIsCypressRunning } from "constants/constants";
import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { useMemo } from "react";

const shouldAlwaysStartTrendChartBarsOnHourAtom = atomWithStorage(
  "atom:shouldAlwaysStartTrendChartBarsOnHour",
  getIsCypressRunning() ? false : true
);

export const useTrendChartStore = () => {
  const [
    shouldAlwaysStartTrendChartBarsOnHour,
    setShouldAlwaysStartTrendChartBarsOnHour,
  ] = useAtom(shouldAlwaysStartTrendChartBarsOnHourAtom);
  return useMemo(
    () => ({
      shouldAlwaysStartTrendChartBarsOnHour,
      setShouldAlwaysStartTrendChartBarsOnHour,
    }),
    [
      setShouldAlwaysStartTrendChartBarsOnHour,
      shouldAlwaysStartTrendChartBarsOnHour,
    ]
  );
};
